import { ChangeDetectionStrategy, Component, DoCheck, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { AFormat, Box, BoxLevel, CardTemplate, Character } from '@df/interfaces';
import { Router } from '@angular/router';
import {
    EXERCISE_CALCULATION,
    EXERCISE_LOGIC,
    EXERCISE_MAGIC_BOX,
    EXERCISE_SEQUENCE,
    EXERCISE_TASK,
    EXERCISE_PUZZLE_EXAMPLE,
    EXERCISE_PUZZLE_TASK,
    EXERCISE_INSERT,
    MAIN_DOMAIN
} from '@app/app.constants';

@Component({
    selector: 'app-template-card',
    templateUrl: './template-card.component.html',
    styleUrls: ['./template-card.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class TemplateCardComponent implements OnInit, OnChanges, DoCheck {
    @Input() box: Box;
    @Input() cardTemplate: CardTemplate;
    @Input() cardFormat: string;
    @Input() boxLevels: Array<BoxLevel>;
    @Input() character: Character;
    @Input() mainCardView = false;
    @Input() lessonDate: Date;

    main_domain = MAIN_DOMAIN;
    isSmartSprintUrl = false;

    magic_box = EXERCISE_MAGIC_BOX;
    calculation = EXERCISE_CALCULATION;
    logic = EXERCISE_LOGIC;
    task = EXERCISE_TASK;
    puzzle_task = EXERCISE_PUZZLE_TASK;
    puzzle_example = EXERCISE_PUZZLE_EXAMPLE;
    sequence = EXERCISE_SEQUENCE;
    insert = EXERCISE_INSERT;
    mb_body: Array<any>;
    currentBoxLevel: BoxLevel;

    constructor(private router: Router) {}

    ngOnInit() {
        if (this.router.url.includes('/student/smart_sprint/pupil/')) {
            this.isSmartSprintUrl = true;
        }
    }

    ngOnChanges(simpleChanges: SimpleChanges): void {
        if (simpleChanges.cardTemplate) {
            if (
                simpleChanges.cardTemplate.currentValue.exercises.length > 0 &&
                simpleChanges.cardTemplate.currentValue.exercises[0].type === EXERCISE_MAGIC_BOX
            ) {
                this.mb_body = JSON.parse(simpleChanges.cardTemplate.currentValue.exercises[0].text);
            }
        }
    }

    ngDoCheck(): void {
        this.updateBoxLevel();
    }

    updateBoxLevel() {
        for (const boxLevel of this.boxLevels) {
            if (+this.box.level === boxLevel.id) {
                this.currentBoxLevel = boxLevel;
                break;
            }
        }
    }

    getFont(format: string) {
        let fs = '8px';
        switch (format) {
            case AFormat.A7_FORMAT:
                fs = '8px';
                break;
            case AFormat.A5_FORMAT:
                fs = '6px';
                break;
            case AFormat.A3_FORMAT:
                fs = '8px';
                break;
        }
        return fs;
    }

    getMargin(exercise_type: string) {
        if (
            exercise_type === EXERCISE_LOGIC ||
            exercise_type === EXERCISE_TASK ||
            exercise_type === EXERCISE_SEQUENCE
        ) {
            return '70px';
        }
        return 'auto';
    }

    getCardInforMargin() {
        if (this.cardFormat === AFormat.A7_FORMAT) {
            return '15px';
        }
        if (this.cardFormat === AFormat.A6_FORMAT) {
            return '40px';
        }
        if (this.cardFormat === AFormat.A5_FORMAT) {
            return '10px';
        }
        if (this.cardFormat === AFormat.A3_FORMAT) {
            return '30px';
        }
        return '10px';
    }

    getCardInfoFontSize() {
        if (this.cardFormat === AFormat.A7_FORMAT) {
            return '8px';
        }
        if (this.cardFormat === AFormat.A5_FORMAT) {
            return '9px';
        }
        return '10px';
    }

    getImageLeft() {
        if (this.mainCardView) {
            if (this.cardFormat === AFormat.A7_FORMAT) {
                return '55%';
            }
            if (this.cardFormat === AFormat.A6_FORMAT) {
                return '0';
            }
            if (this.cardFormat === AFormat.A5_FORMAT) {
                return '70%';
            }
            return '60%';
        } else {
            if (this.cardFormat === AFormat.A7_FORMAT) {
                return '68%';
            }
            if (this.cardFormat === AFormat.A5_FORMAT) {
                return '70%';
            }
            if (this.cardFormat === AFormat.A6_FORMAT) {
                return '0';
            }
            return '80%';
        }
    }

    getImageWidth() {
        if (this.cardFormat === AFormat.A6_FORMAT) {
            return '30%';
        }
        if (this.cardFormat === AFormat.A5_FORMAT) {
            return '55%';
        }
        if (this.cardFormat === AFormat.A7_FORMAT) {
            return '55%';
        }
        if (this.cardFormat === AFormat.A3_FORMAT) {
            return '45%';
        }
        return '30%';
    }
}
